var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIotx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.153 9.323 13.23 5.916 19.152 2.5l5.924 3.416-5.924 3.407 5.924-3.407L31 9.323V22.97l-5.923-3.408L31 22.969l-5.923 3.415-5.924-3.416 5.924-3.408-5.924 3.407V9.322zm5.924 3.416-5.924 3.406 5.924-3.406 5.583 3.21-5.583-3.211v-.004zM5.405 15.047l-1.505.868V9.093l5.92 3.404 1.479-.853-4.924-2.837L12.302 5.4v6.8l.058.033 5.866-3.373v6.824l-1.052-.606-5.837 3.362 1.586.912-5.5 3.171v2.035L1.5 21.14 7 17.98v-2.014l-1.595-.918zm-.505-.863v-3.363l2.92 1.68-2.92 1.683zm7.415-.823v3.36l2.913-1.677-2.913-1.683zm-1.488 7.731v6.823l2.363-1.364 4.652 2.676v-6.823l-2.368 1.365-4.647-2.677zm6.015 6.406-2.652-1.526 2.551-1.474-.264-.153.366-.21v3.362zm2.263 3.355V24.03l5.914 3.407-5.915 3.418zM18.153 4.23l-2.92 1.685 2.92 1.68V4.23zm-.927 6.359-2.92 1.678 2.92 1.685v-3.364zm1.927 5.556-5.914 3.416 5.913 3.407v-6.824zm-1 1.732-2.912 1.683 2.913 1.679v-3.362zm-14.65 3.264 2.92-1.679v3.364l-2.92-1.685zM30 11.054l-2.92 1.684 2.92 1.68v-3.364zm-8.843 5.093 2.92-1.678v3.36l-2.92-1.683zM30 17.877l-2.92 1.684L30 21.24v-3.363zm-8.843 5.093 2.92-1.68v3.364l-2.92-1.684zm0-13.646 2.92-1.68v3.364l-2.92-1.684z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotx);
export default __webpack_public_path__ + "static/media/IOTX.4473e8226d2af3a6aab82e1e320a1a8d.svg";
export { ForwardRef as ReactComponent };